import { render, staticRenderFns } from "./schoolAdministratorEdit.vue?vue&type=template&id=9dfc0e9c&scoped=true&"
import script from "./schoolAdministratorEdit.vue?vue&type=script&lang=js&"
export * from "./schoolAdministratorEdit.vue?vue&type=script&lang=js&"
import style0 from "./schoolAdministratorEdit.vue?vue&type=style&index=0&id=9dfc0e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfc0e9c",
  null
  
)

export default component.exports